import { Namespace } from '../constants.js';
const THEME_PREFIX = `${Namespace}-theme-`;
/**
 * expected example) "fmc-theme-basic-light"
 */

const getThemeClass = (brand = "basic", themeName = "light") => `${THEME_PREFIX}-${brand}-${themeName}`;

export { getThemeClass };
